'use strict';
var Version = require('./version');

var footer = React.createClass({

  render: function () {
    return (
      <div className="page-footer">
        <Version/>
      </div>
    );
  }

});

module.exports = footer;
